import React from "react";
import "./Icons.scss";

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      className="icon-facebook"
    >
      <g>
        <g className="cls-2">
          <path
            className="cls-3"
            d="M15.79,8.58A7.12,7.12,0,1,1,8.67,1.46a7.12,7.12,0,0,1,7.12,7.12"
          />
          <path
            className="cls-4"
            d="M5.35,11.34a1,1,0,0,1-.64-.63c-.28-.76-.36-4,.18-4.59a1,1,0,0,1,.69-.37A39,39,0,0,1,12,5.81a1,1,0,0,1,.63.6,10,10,0,0,1-.05,4.43.94.94,0,0,1-.45.45,30.05,30.05,0,0,1-6.78.05m2.29-1.5,2.6-1.35L7.64,7.14Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
